import BannerStatic, { BannerType } from 'elem/compCommon/BannerStatic';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function A() {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('powerindependence');
    const IMG_MAP: any = {
        de: '',
    };
    const data: BannerType = {
        src: `/responsive/picture/power-independence/1${IMG_MAP[locale] || IMG_MAP.de}.jpg`,
        srcPad: `/responsive/picture/power-independence/1_375${IMG_MAP[locale] || IMG_MAP.de}.jpg`,
        srcMobile: `/responsive/picture/power-independence/1_375${IMG_MAP[locale] || IMG_MAP.de}.jpg`,
        alt: t('secA_title'),
        title: t('secA_title'),
        desc: t('secA_desc'),
        btnText: t('secA_btn'),
        link: '#power-independence-C',
        theme: 'black',
    };
    return (
        <div className={`power-independence-A ${css['power-independence-A']}`}>
            <BannerStatic {...data} />
        </div>
    );
}
